<select class="form-select" [(ngModel)]="model" id="time" name="time" (ngModelChange)="eventChange()">
  <!-- <option [ngValue]="'00:00'">00:00</option>
  <option [ngValue]="'00:15'">00:15</option>
  <option [ngValue]="'00:30'">00:30</option>
  <option [ngValue]="'00:45'">00:45</option>
  <option [ngValue]="'01:00'">01:00</option>
  <option [ngValue]="'01:15'">01:15</option>
  <option [ngValue]="'01:30'">01:30</option>
  <option [ngValue]="'01:45'">01:45</option>
  <option [ngValue]="'02:00'">02:00</option>
  <option [ngValue]="'02:15'">02:15</option>
  <option [ngValue]="'02:30'">02:30</option>
  <option [ngValue]="'02:45'">02:45</option>
  <option [ngValue]="'03:00'">03:00</option>
  <option [ngValue]="'03:15'">03:15</option>
  <option [ngValue]="'03:30'">03:30</option>
  <option [ngValue]="'03:45'">03:45</option>
  <option [ngValue]="'04:00'">04:00</option>
  <option [ngValue]="'04:15'">04:15</option>
  <option [ngValue]="'04:30'">04:30</option>
  <option [ngValue]="'04:45'">04:45</option>
  <option [ngValue]="'05:00'">05:00</option>
  <option [ngValue]="'05:15'">05:15</option>
  <option [ngValue]="'05:30'">05:30</option>
  <option [ngValue]="'05:45'">05:45</option> -->
  <option [ngValue]="'06:00'">06:00</option>
  <option [ngValue]="'06:15'">06:15</option>
  <option [ngValue]="'06:30'">06:30</option>
  <option [ngValue]="'06:45'">06:45</option>
  <option [ngValue]="'07:00'">07:00</option>
  <option [ngValue]="'07:15'">07:15</option>
  <option [ngValue]="'07:30'">07:30</option>
  <option [ngValue]="'07:45'">07:45</option>
  <option [ngValue]="'08:00'">08:00</option>
  <option [ngValue]="'08:15'">08:15</option>
  <option [ngValue]="'08:30'">08:30</option>
  <option [ngValue]="'08:45'">08:45</option>
  <option [ngValue]="'09:00'">09:00</option>
  <option [ngValue]="'09:15'">09:15</option>
  <option [ngValue]="'09:30'">09:30</option>
  <option [ngValue]="'09:45'">09:45</option>
  <option [ngValue]="'10:00'">10:00</option>
  <option [ngValue]="'10:15'">10:15</option>
  <option [ngValue]="'10:30'">10:30</option>
  <option [ngValue]="'10:45'">10:45</option>
  <option [ngValue]="'11:00'">11:00</option>
  <option [ngValue]="'11:15'">11:15</option>
  <option [ngValue]="'11:30'">11:30</option>
  <option [ngValue]="'11:45'">11:45</option>
  <option [ngValue]="'12:00'">12:00</option>
  <option [ngValue]="'12:15'">12:15</option>
  <option [ngValue]="'12:30'">12:30</option>
  <option [ngValue]="'12:45'">12:45</option>
  <option [ngValue]="'13:00'">13:00</option>
  <option [ngValue]="'13:15'">13:15</option>
  <option [ngValue]="'13:30'">13:30</option>
  <option [ngValue]="'13:45'">13:45</option>
  <option [ngValue]="'14:00'">14:00</option>
  <option [ngValue]="'14:15'">14:15</option>
  <option [ngValue]="'14:30'">14:30</option>
  <option [ngValue]="'14:45'">14:45</option>
  <option [ngValue]="'15:00'">15:00</option>
  <option [ngValue]="'15:15'">15:15</option>
  <option [ngValue]="'15:30'">15:30</option>
  <option [ngValue]="'15:45'">15:45</option>
  <option [ngValue]="'16:00'">16:00</option>
  <option [ngValue]="'16:15'">16:15</option>
  <option [ngValue]="'16:30'">16:30</option>
  <option [ngValue]="'16:45'">16:45</option>
  <option [ngValue]="'17:00'">17:00</option>
  <option [ngValue]="'17:15'">17:15</option>
  <option [ngValue]="'17:30'">17:30</option>
  <option [ngValue]="'17:45'">17:45</option>
  <option [ngValue]="'18:00'">18:00</option>
  <option [ngValue]="'18:15'">18:15</option>
  <option [ngValue]="'18:30'">18:30</option>
  <option [ngValue]="'18:45'">18:45</option>
  <option [ngValue]="'19:00'">19:00</option>
  <option [ngValue]="'19:15'">19:15</option>
  <option [ngValue]="'19:30'">19:30</option>
  <option [ngValue]="'19:45'">19:45</option>
  <option [ngValue]="'20:00'">20:00</option>
  <option [ngValue]="'20:15'">20:15</option>
  <option [ngValue]="'20:30'">20:30</option>
  <option [ngValue]="'20:45'">20:45</option>
  <option [ngValue]="'21:00'">21:00</option>
  <option [ngValue]="'21:15'">21:15</option>
  <option [ngValue]="'21:30'">21:30</option>
  <option [ngValue]="'21:45'">21:45</option>
  <option [ngValue]="'22:00'">22:00</option>
  <!-- <option [ngValue]="'22:15'">22:15</option>
  <option [ngValue]="'22:30'">22:30</option>
  <option [ngValue]="'22:45'">22:45</option>
  <option [ngValue]="'23:00'">23:00</option>
  <option [ngValue]="'23:15'">23:15</option>
  <option [ngValue]="'23:30'">23:30</option>
  <option [ngValue]="'23:45'">23:45</option> -->
</select>